import { styled } from '@mui/system'
import type { Theme } from '@mui/material/styles'
import { Button, MenuItem } from '@mui/material'
import { blue, shade, grey } from '../../../colors'

interface InstitutionDropdownProps {
  theme?: Theme
  active?: boolean | null
  isTablet: boolean
  isMobile: boolean
}

export const InstitutionDropdown = styled(Button)<InstitutionDropdownProps>(({ theme, active, isMobile }) => ({
  color: (active ?? false) ? blue[500] : grey[50],
  textTransform: 'capitalize',
  background: active ? shade[1] : 'transparent',
  fontWeight: isMobile ? 'unset' : 'bold',
  cursor: 'pointer',
  letterSpacing: '1%',
  position: 'relative',
  fontSize: isMobile ? theme.spacing(3) : theme.spacing(4),
  // MUI Button defaults to minWidth 64px; slightly tighter horizontal padding matches adjacent nav controls (esp. label + chevron)
  minWidth: 'auto',
  padding: `${theme.spacing(2)} ${theme.spacing(2)}`,
  transition: '.3s',
  borderRadius: `${theme.spacing(3)}`,
  display: 'flex',
  alignItems: 'center',
  gap: 2,

  '&:hover': {
    background: blue[100],
    color: theme.palette.primary.main
  }

}))
interface StyledMenuItemProps {
  theme?: Theme
  active?: boolean | null
}

export const StyledMenuItem = styled(MenuItem)<StyledMenuItemProps>(({ theme, active }) => ({
  fontSize: '16px',
  fontWeight: 500,
  padding: `${theme.spacing(2.5)} ${theme.spacing(4)}`,
  color: (active ?? false) ? blue[500] : grey[250],
  background: (active ?? false) ? shade[1] : 'unset',

  '&:hover': {
    background: shade[150]
  }
}))

interface StyledGroupNameProps {
  theme?: Theme
}
export const StyledGroupName = styled(MenuItem)<StyledGroupNameProps>(({ theme }) => ({
  color: grey[850],
  padding: `${theme.spacing(1.5)} ${theme.spacing(4)}`,
  fontWeight: '700',
  fontSize: '12px',
  textTransform: 'uppercase',
  cursor: 'default',
  pointerEvents: 'none',
  '&:hover': {
    background: 'transparent'
  }

}))
